import { all } from 'redux-saga/effects';
import devicesWatcher from './devices';
import usersWatcher from './users';
import collectionsWatcher from './collections';

export default function* root() {
  yield all([devicesWatcher(), usersWatcher(), collectionsWatcher()]);
}
